import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Container from '@mui/material/Container';
import { Box, Typography, Stack, Button, Badge, Paper, Alert, AlertTitle, Divider, Grid, Toolbar, Card, Link } from '@mui/material';
import OverlaySpinner from './Controls/OverlaySpinner';
import PostLoginMenu from './PostLoginMenu'
import Footer from './Footer';
//import EnrollmentHeader from './EnrollmentHeader'
import { DrawerAppBar } from './AppNavbar'
//import Accordion from '@mui/material/Accordion';
//import AccordionSummary from '@mui/material/AccordionSummary';
//import AccordionDetails from '@mui/material/AccordionDetails';
//import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
//import pwdimg from '../assets/images/Online protection_Monochromatic.png';
import { useNavigate } from "react-router-dom";
//import { RedirectToHome } from '../global/Helpers';
import { GetLoggedInUserEmail } from '../global/APIUtils';
//import { ReactComponent as ReactLogo } from '../assets/images/ssb-horizontal-new.svg';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import { useLocation } from "react-router-dom";
import clientlogo from '../assets/images/ssb-logo-lpl-blue.png';
//import clientlogo from '../assets/images/demo_bank_logo.jpg';
import ClientLogoHeader from './ClientLogoHead'
import EnrollmentHeader from './EnrollmentHeader'
import { ActivityLogEvent } from '../common/AOBEnum';
import { WriteToActivityLog } from '../global/Api';

const ChangePasswordOption = () => {

    const location = useLocation();

    const [isLoading, setIsLoading] = useState(false);
    const [expanded, setExpanded] = useState(true);
    const [isProspect, setProspect] = useState(true);
    const [role, setRole] = useState('');
    const [emailAddress, setEmailAddress] = useState('');
    const [userId, setUserId] = useState(location.state.userId || -1);
    const [sessionId, setSessionId] = useState(location.state.sessionId || '');

    const sessions = useSelector((state) => state.sessionMgmnt);
    let navigate = useNavigate();

    const handleAccordianChange = () => {
        if (expanded) {
            setExpanded(false);
        }
        else {
            setExpanded(true);
        }
    };

    const ContinueHome = async (event) => {
        event.preventDefault();

        await WriteToActivityLog(ActivityLogEvent.ForgotPassword, "Did not change password. Continued to home page.", userId, sessionId);

        navigate('/UserHome', { state: { userId: userId, sessionId: sessionId }, replace: true });
    };

    const UpdatePassword = (event) => {
        event.preventDefault();
        navigate('/CreatePassword', { state: { userId: userId, sessionId: sessionId }, replace: true });
    };

    useEffect(() => {

        let userEmailAddr = GetLoggedInUserEmail(userId, sessionId);
        setEmailAddress(userEmailAddr);

    }, []);

    return (
        <React.Fragment>
            <Container maxWidth="lg" sx={{}} disableGutters={true}>
                <OverlaySpinner disappear={isLoading} />
                <Paper className="back-grid">
                    <PostLoginMenu userId={userId} sessionId={sessionId} />
                    <Grid item md={12} >
                        <EnrollmentHeader />
                    </Grid>


                    {/*<Toolbar sx={{ borderBottom: 1, borderColor: '#f5f5f5', justifyContent: 'space-between', backgroundColor: '#fff', pt: 1, pb: 1, boxShadow: '0 1px 5px 0 rgba(32, 33, 36, 0.28)' }}>*/}
                    {/*    <Box sx={{ ml: 2, pt: 2, pb: 2 }}>*/}
                    {/*        <img src={clientlogo} height="44" loading="lazy" />*/}
                    {/*    </Box>*/}
                    {/*</Toolbar>*/}

                    {/*<Toolbar sx={{ borderBottom: 1, borderColor: 'divider', justifyContent: 'space-between', backgroundColor: '#fff', pt: 0, pb: 0 }}>*/}
                    {/*    <Box sx={{ display: 'flex', alignItems: 'center', ml: 1, mt: 4, mb: 1, pb: 1 }}>*/}
                    {/*        <img src={clientlogo} height="44" loading="lazy" />*/}
                    {/*    </Box>*/}
                    {/*</Toolbar>                  */}
                    <Grid container justifyContent="center" spacing={0} sx={{ pt: 4, }}>
                        <Grid item md={3}>
                        </Grid>
                        <Grid item md={6} sx={{ pr: 2, pt: 4, pb: 7.5 }} justifyContent="center">
                            <Card elevation={3} sx={{ mx: 'auto', border: 0, borderColor: '#9FA4A8', borderRadius: '6px', pt: 2, }}>
                                <Box textAlign='center' sx={{ pt: 3 }}>
                                    <DoneAllIcon sx={{ fontSize: 40, color: '#747C81' }} />
                                    {/*    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500" width="128" height="128"><title>Approved</title><path d="M250,159S148.71,193.6,176.86,270.18s87.85,73.21,87.85,73.21-88,17.48-108.12-68.71S221.78,156,250,159Z" fill="#3fe2fd"></path><path d="M185.28,159.34c-10.19,7.65-25.67,6.39-34.46,15.62s-6.61,23.49-8.09,36a57.57,57.57,0,0,1-9.21,25c-3.65,5.48-8.47,11.05-8,17.62.54,7,6.93,11.91,10.89,17.74,8.24,12.12,5.81,28.16,5.23,42.8-.12,3.13-.11,6.43,1.43,9.17,3.71,6.61,13.14,6,20.57,7.55,17.72,3.69,27.5,22.85,31.48,40.51a73.78,73.78,0,0,0-53.07-34.8c-2.67-.35-5.62-.67-7.41-2.67a9.05,9.05,0,0,1-1.87-4.53c-2.52-14,4.89-29.15-.67-42.24-4.16-9.79-14.66-15.77-18.82-25.56-4.34-10.25-.7-22.11,4.36-32S129.28,210,131.05,199c2.1-13.14-2.23-28.9,7.19-38.31,7.4-7.38,19.58-6.59,28.86-11.38s14.77-14.73,21.4-22.93c5.63-7,16.22-15.89,25.81-12.25-4,7.18-10.54,12.45-14.23,20.73C196.21,143.6,193.24,153.38,185.28,159.34Z" fill="#3fe2fd"></path><path d="M377,208.74c-1.5-4.6-.55-11.6.37-18.36,1.39-10.26,3-21.88-3.31-30.52s-18-10.81-28.21-12.65c-6.66-1.19-13.56-2.43-17.38-5.21s-7-8.84-10.15-14.75c-4.93-9.25-10.53-19.73-20.92-23.11-10-3.24-20,1.58-29.69,6.25-6.24,3-12.7,6.13-17.7,6.13s-11.46-3.12-17.7-6.13c-9.68-4.67-19.7-9.5-29.69-6.25-10.4,3.38-16,13.86-20.92,23.11-3.15,5.91-6.42,12-10.15,14.75s-10.72,4-17.38,5.21c-10.25,1.84-21.86,3.93-28.2,12.65s-4.71,20.26-3.32,30.52c.92,6.76,1.87,13.76.37,18.36-1.38,4.26-6.11,9.17-10.69,13.92C105,230.26,96.67,238.88,96.67,250s8.31,19.74,15.65,27.34c4.58,4.75,9.31,9.67,10.69,13.92,1.5,4.6.55,11.6-.37,18.36-1.39,10.26-3,21.88,3.31,30.52s18,10.81,28.21,12.65c6.66,1.19,13.56,2.43,17.38,5.21s7,8.84,10.15,14.75c4.93,9.25,10.52,19.73,20.92,23.11a21.79,21.79,0,0,0,6.81,1.06c7.72,0,15.4-3.7,22.88-7.31,6.24-3,12.7-6.13,17.7-6.13s11.46,3.12,17.7,6.13c9.68,4.67,19.69,9.49,29.69,6.25,10.4-3.38,16-13.86,20.92-23.11,3.15-5.91,6.42-12,10.15-14.75s10.72-4,17.38-5.21c10.25-1.84,21.86-3.93,28.21-12.65s4.7-20.26,3.31-30.52c-.92-6.76-1.87-13.76-.37-18.36,1.38-4.25,6.11-9.17,10.69-13.92,7.34-7.6,15.65-16.22,15.65-27.34s-8.31-19.74-15.65-27.34C383.1,217.91,378.37,213,377,208.74Zm.62,58.89c-5.69,5.89-11.56,12-13.94,19.31-2.48,7.63-1.31,16.24-.18,24.56,1.09,8,2.21,16.31-.76,20.4s-11.34,5.66-19.36,7.11c-8.22,1.47-16.73,3-23.15,7.67S309.86,358.85,306,366.16s-7.87,14.75-12.89,16.38c-4.65,1.51-12.09-2.07-19.29-5.54-7.66-3.7-15.58-7.52-23.78-7.52s-16.12,3.82-23.78,7.52c-7.2,3.47-14.64,7.06-19.29,5.54-5-1.63-9-9.13-12.89-16.38s-7.93-14.87-14.26-19.48-14.93-6.2-23.15-7.67c-8-1.45-16.32-2.94-19.36-7.11s-1.85-12.38-.76-20.4c1.13-8.32,2.3-16.92-.18-24.56-2.38-7.33-8.25-13.42-13.94-19.31S110.67,255.47,110.67,250s6-11.65,11.72-17.63,11.56-12,13.94-19.31c2.48-7.63,1.31-16.24.18-24.56-1.09-8-2.21-16.31.76-20.4s11.34-5.66,19.36-7.11c8.22-1.47,16.73-3,23.15-7.67s10.36-12.17,14.26-19.48,7.87-14.75,12.89-16.38a7.78,7.78,0,0,1,2.46-.36c4.59,0,10.79,3,16.83,5.9,7.66,3.7,15.58,7.52,23.78,7.52s16.12-3.82,23.78-7.52c7.2-3.47,14.64-7.06,19.28-5.54,5,1.63,9,9.13,12.9,16.38s7.93,14.87,14.26,19.48,14.93,6.2,23.15,7.67c8,1.45,16.32,2.94,19.36,7.11s1.85,12.38.76,20.4c-1.13,8.32-2.3,16.92.18,24.56,2.38,7.33,8.25,13.42,13.94,19.31s11.72,12.16,11.72,17.63S383.37,261.65,377.61,267.63Z" fill="#251ac7"></path><path d="M250,145A105,105,0,1,0,355,250,105.09,105.09,0,0,0,250,145Zm0,196a91,91,0,1,1,91-91A91.08,91.08,0,0,1,250,341Z" fill="#251ac7"></path><path d="M289,215.67l-50.82,49.89L218,243.43a7,7,0,0,0-10.35,9.44l25.09,27.49a7,7,0,0,0,5,2.28h.19a7,7,0,0,0,4.9-2l56-55a7,7,0,1,0-9.81-10Z" fill="#251ac7"></path></svg>*/}
                                </Box>
                                <Typography variant="h4" gutterBottom align="center" sx={{ fontSize: '20px', pt: 0, fontWeight: 500 }} color="text.secondary">Verification successful</Typography>
                                <Typography variant="body1" align="center" sx={{}} color="text.primary">{emailAddress}</Typography>
                                <Box sx={{ ml: 4, mr: 4, mt: 4 }}>
                                    <Divider variant="fullWidth" component="div" sx={{ background: '#BBBFBF' }} />
                                </Box>
                                <Typography align="center" sx={{ mb: 2, mt: 5.5, fontWeight: 400 }} variant="body1" color="text.primary">
                                    You can update your password now if you don't know or forgot it.
                                </Typography>
                                <Box
                                    component="span"
                                    m={1}
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    sx={{ pl: 5, pr: 5, pb: 8.5, pt: 4.5 }}
                                >
                                    <Link color="primary" onClick={UpdatePassword} underline="hover" sx={{ textTransform: 'none', color: 'Link.main' }}>
                                        Update password
                                    </Link>

                                    <Button type="submit" variant="contained" size="large" style={{ borderRadius: '20px', padding: '0.3rem 2.2rem', textTransform: 'none' }} onClick={ContinueHome} >
                                        Continue
                                    </Button>

                                    {/*<Button variant="outlined" size="small" onClick={ContinueHome} sx={{ padding: '0.4rem 2.5rem', border: 2, borderColor: '#616161' }}>*/}
                                    {/*    <Typography variant="body2" color="#212121" sx={{ textTransform: 'none', fontWeight: 500 }} >Continue</Typography>*/}
                                    {/*</Button>*/}

                                    {/*<Button variant="contained" size="large" onClick={ContinueHome} style={{ padding: '0.5rem 2rem', textTransform: 'none', outline: 'none', }}>*/}
                                    {/*    <Typography variant="subtitle1">Continue</Typography>*/}
                                    {/*</Button>*/}
                                    {/*<Button color="primary" sx={{ height: 40, }}>*/}
                                    {/*    Continue*/}
                                    {/*</Button>*/}
                                </Box>
                            </Card>
                        </Grid>
                        <Grid item md={3} >
                        </Grid>
                        {/*<Grid item md={5}>*/}
                        {/*    <Grid container>*/}
                        {/*        <Grid item md={10} sx={{}} >*/}
                        {/*            <Image src={pwdimg} aspectRatio={1.1} />*/}
                        {/*        </Grid>*/}
                        {/*    </Grid>*/}
                        {/*</Grid>*/}
                    </Grid>
                    <Footer />
                </Paper>
            </Container>
        </React.Fragment>
    );
}

export default ChangePasswordOption;